// Code from: https://www.particleincell.com/2013/cubic-line-intersection/
export function computeIntersections(curve, line) {
    let intersections = [];
    let X = [];
    let A = line.p2.y - line.p1.y;
    let B = line.p1.x - line.p2.x;
    let C = line.p1.x * (line.p1.y - line.p2.y) + line.p1.y * (line.p2.x - line.p1.x);
    let bx = bezierCoeffs(curve.p1.x, curve.cp1.x, curve.cp2.x, curve.p2.x);
    let by = bezierCoeffs(curve.p1.y, curve.cp1.y, curve.cp2.y, curve.p2.y);
    let P = [];
    P[0] = A * bx[0] + B * by[0];
    P[1] = A * bx[1] + B * by[1];
    P[2] = A * bx[2] + B * by[2];
    P[3] = A * bx[3] + B * by[3] + C;
    let r = cubicRoots(P);
    for (let i = 0; i < 3; i++) {
        let t = r[i];
        let s;
        X[0] = bx[0] * t * t * t + bx[1] * t * t + bx[2] * t + bx[3];
        X[1] = by[0] * t * t * t + by[1] * t * t + by[2] * t + by[3];
        if ((line.p2.x - line.p1.x) != 0) {
            s = (X[0] - line.p1.x) / (line.p2.x - line.p1.x);
        }
        else {
            s = (X[1] - line.p1.y) / (line.p2.y - line.p1.y);
        }
        if (t > 0 && t < 1.0 && s > 0 && s < 1.0)
            intersections.push({ x: X[0], y: X[1] });
    }
    return intersections;
}
function cubicRoots(P) {
    let a = P[0];
    let b = P[1];
    let c = P[2];
    let d = P[3];
    let A = b / a;
    let B = c / a;
    let C = d / a;
    let Q = (3 * B - Math.pow(A, 2)) / 9;
    let R = (9 * A * B - 27 * C - 2 * Math.pow(A, 3)) / 54;
    let D = Math.pow(Q, 3) + Math.pow(R, 2);
    let t = [];
    if (D >= 0) {
        let S = sgn(R + Math.sqrt(D)) * Math.pow(Math.abs(R + Math.sqrt(D)), (1 / 3));
        let T = sgn(R - Math.sqrt(D)) * Math.pow(Math.abs(R - Math.sqrt(D)), (1 / 3));
        t[0] = -A / 3 + (S + T);
        t[1] = -A / 3 - (S + T) / 2;
        t[2] = -A / 3 - (S + T) / 2;
        if (Math.abs(Math.sqrt(3) * (S - T) / 2) != 0) {
            t[1] = -1;
            t[2] = -1;
        }
    }
    else {
        let th = Math.acos(R / Math.sqrt(-Math.pow(Q, 3)));
        t[0] = 2 * Math.sqrt(-Q) * Math.cos(th / 3) - A / 3;
        t[1] = 2 * Math.sqrt(-Q) * Math.cos((th + 2 * Math.PI) / 3) - A / 3;
        t[2] = 2 * Math.sqrt(-Q) * Math.cos((th + 4 * Math.PI) / 3) - A / 3;
    }
    for (let i = 0; i < 3; i++) {
        if (t[i] < 0 || t[i] > 1.0)
            t[i] = -1;
    }
    t = sortSpecial(t);
    return t;
}
function bezierCoeffs(P0, P1, P2, P3) {
    let Z = [];
    Z[0] = -P0 + 3 * P1 + -3 * P2 + P3;
    Z[1] = 3 * P0 - 6 * P1 + 3 * P2;
    Z[2] = -3 * P0 + 3 * P1;
    Z[3] = P0;
    return Z;
}
function sortSpecial(a) {
    let flip;
    let temp;
    do {
        flip = false;
        for (var i = 0; i < a.length - 1; i++) {
            if ((a[i + 1] >= 0 && a[i] > a[i + 1]) ||
                (a[i] < 0 && a[i + 1] >= 0)) {
                flip = true;
                temp = a[i];
                a[i] = a[i + 1];
                a[i + 1] = temp;
            }
        }
    } while (flip);
    return a;
}
function sgn(x) {
    return x < 0.0 ? -1 : 1;
}
